import(/* webpackMode: "eager", webpackExports: ["PageClient"] */ "/app/src/app/(training)/task/[name]/submissions/page-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/components/link.tsx");
